<template>
  <div :class="$style.wrapper">
    <div
      v-for="option in options"
      :key="option.value"
      :class="[isSelected(option.value) ? $style.active : '', $style.toggleButton]"
      @click="toggleSelect(option.value)"
    >
      <span>{{ option.label }}</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: "IOS",
  },
  options: Array,
});

const emit = defineEmits(["update:modelValue", "refetch"]);

const isSelected = (value) => props.modelValue === value;

const toggleSelect = (value) => {
  if (!isSelected(value)) {
    emit("update:modelValue", value);
  }
  emit("refetch");
};
</script>

<style module lang="scss">
.wrapper {
  display: flex;
}

.toggleButton {
  cursor: pointer;
  padding: 0.7rem 1rem;
  border: 1px solid #ccc;
  background-color: var(--vd-color-white);
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--vd-color-text-default);
  font-weight: bolder;

  &:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.active {
  background-color: var(--vd-base-primary-color);
  color: var(--vd-color-white);
  border-color: var(--vd-base-primary-color);
}

.icon {
  width: 24px;
  height: 24px;
}
</style>
